export default "__VITE_ASSET__93fabd56__"